// WidgetTable.js
import React from "react";
import { Table, Space, Tooltip, InputNumber, Input, Form } from "antd";
import moment from 'moment';
// import "antd/dist/antd.css";

class WidgetTable extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: undefined,
            columns: [],
            options: props.options,
            pagination: {
                current: props.page || 1,
                pageSize: props.options.records || 10,
                hideOnSinglePage: props.options.hideOnSinglePage || false,
                showSizeChanger: true,
            },
            loading: true,
            rowSelection: undefined,
            selectedRowKeys: props.selectedRowKeys ? props.selectedRowKeys : [],
            rowKey: undefined,
            locale: {
                selectionAll: "全选",
                selectInvert: "反选",
                selectNone: "清空"
            },
            width: props.width || 1500,
            scroll: {
                x: 1500
            },
            editingKey: '',
            bordered: props.bordered || false,
        };

        // 获取组件自身
        this.myRef = React.createRef();

        this.buildColumns = this.buildColumns.bind(this);
        this.buildData = this.buildData.bind(this);
    }


    /**
     * 表格操作回调函数
     * @param {JSON} pagination 
     * @param {JSON} filters 
     * @param {JSON} sorter 
     * @param {JSON} event 
     */
    onChange = async (pagination, filters, sorter, event) => {


        if (event.action === "paginate") {
            if (this.props.pageTurning !== undefined) {
                this.props.pageTurning(pagination.current, pagination.pageSize, pagination);
                // this.props.pageTurning(pagination.current);
            }

            await this.setState({ pagination });
        }
        else if (event.action === "sort") {
            if (this.props.notify !== undefined) {
                this.props.notify("sort", sorter);
            }
        }
        else if (event.action === "filter") {
            if (this.props.notify !== undefined) {
                this.props.notify("filter", filters);
            }
        }
    }

    /**
     * 表格事件处理
     * @param {string} type 
     * @param {JSON} data 
     * @param {string} value 
     * @param {string} index 
     * @param {JSON} event 
     * @returns 
     */
    notify = (type, data, value, index, event) => {
        if (type === "paginate") {
            if (this.props.pageTurning !== undefined) {
                this.props.pageTurning(data);
            }
            this.setState({ pagination: data });
        }
        else {
            if (this.props.notify !== undefined) {
                return this.props.notify(type, data, value, index, event, this.notify);
            }
        }
    }

    /**
     * 表格选择
     * @param {*} rowKeys 
     * @param {*} selectedRows 
     */
    onSelectChange = (selectedRowKeys, selectedRows) => {

        if (this.props.notify !== undefined) {
            this.props.notify("check", selectedRowKeys, selectedRows);
        }

        this.setState({ selectedRowKeys: selectedRowKeys });
    };

    editClick = (record) => () => {
        let tableColumns = this.buildColumns();
        this.setState({ editingKey: record.key, columns: tableColumns })

        // return record.isEdit = true
    }

    onEditChange = (type, data, value, event) => {
        console.log(type, data, value, event)
    }

    isEditing = (record) => {
        return record.key === this.state.editingKey
    }

    /**
     * 创建表格列
     * @returns 
     */
    buildColumns() {
        let tableColumns = [];

        let { selectedRowKeys, options } = this.state;

        let { columns } = this.props;

        if (options.check !== undefined && options.check !== null && options.check.enable === true) {
            const rowSelection = {

                selectedRowKeys,
                onChange: this.onSelectChange,
                selections: [
                    Table.SELECTION_ALL,
                    Table.SELECTION_INVERT,
                    Table.SELECTION_NONE
                ]
            };

            this.setState({ rowSelection: rowSelection, rowKey: options.check.key });
        }

        if (options.isSerial !== false) {
            tableColumns.push({
                dataIndex: "serial",
                title: "序号",
                type: "integer",
                className: "table-serial",
                align: 'center',
                width: 80
            });
        }
        for (let column of columns) {
            if (column.properties !== undefined && column.properties.hidden === true) {
                continue;
            }

            let tableColumn = {
                dataIndex: column.name,
                title: column.title,
            };
            if (column.render) {
                tableColumn['render'] = column.render
            }


            if (column.properties && column.properties.width) {
                tableColumn["width"] = column.properties.width
            }

            if (column.properties !== undefined) {

                tableColumn = { ...tableColumn, ...column.properties };

                // 固定列
                if (column.properties.fixed !== undefined) {
                    tableColumn["fixed"] = column.properties.fixed;
                }

                // 列样式
                if (column.properties.className !== undefined) {
                    tableColumn["className"] = column.properties.className;
                }

                // 排序
                if (column.properties.sorter !== undefined) {
                    tableColumn["sorter"] = column.properties.sorter;
                }

                // 可编辑
                if (column.properties.editable !== undefined) {
                    tableColumn["editable"] = column.properties.editable;
                    // tableColumn['filterDropdown'] = true
                    // tableColumn['filterIcon'] = <img className="sf-edit-icon" onClick={this.editClick} src={require('../css/widget/img/edit.png')} />
                    tableColumn["render"] = (text, record, index) => {
                        const isEdit = this.isEditing(record);
                        return <div className="sf-edit-cell">

                            {
                                isEdit ? <Input defaultValue={text} onChange={(e) => { this.onEditChange("editing", JSON.stringify(record), e.target.value, { event: e }) }} /> : <span>{text}</span>

                            }
                            <p>
                                {
                                    isEdit ? <>
                                        <img src={require('../css/widget/img/save.png')} />
                                        <img src={require('../css/widget/img/cancel.png')} />
                                    </> : <img className="sf-edit-icon" onClick={this.editClick(record)} src={require('../css/widget/img/edit.png')} />
                                }
                            </p>
                        </div>
                    }

                    // tableColumn["onHeaderCell"] = (column) => {
                    //     console.log(column, 11111)
                    //     // return <div ><span>{column.title}</span> <img src={require('../img/frame/add_btn_line.svg')} /></div>
                    //     // this.edit(column, "HeaderCell-edit", column.name);
                    //     tableColumn["render"] = (text, record) => {

                    //         console.log(text, record,2222222)
                    //         return <div ><span>{column.title}</span> <img src={require('../img/frame/add_btn_line.svg')} /></div>
                    //     }
                    // };

                    // tableColumn["onCell"] = (column) => {

                    //     // this.edit(column, "cell-edit", column.name);
                    // };



                }

                // 显示提示
                if (column.properties.showTips !== undefined) {
                    tableColumn["render"] = (text, record) => {
                        return (
                            <Tooltip placement="topLeft" title={text}>
                                {text}
                            </Tooltip>
                        )
                    }
                }

                // 点击
                if (column.properties.click !== undefined) {
                    tableColumn["render"] = (text, record, index) => {

                        // return <a key={index} onClick={()=>{this.notify( column.properties.click, record, text)}}>{text}</a>
                        return <a key={index} onClick={() => { this.notify(column.properties.click, record, text) }}>{text}</a>

                    };
                }

                // if( column.properties.format!==undefined )
                // {
                //     tableColumn['render'] = (text, record, index) => {
                //         let vals = Object.values(record);
                //         let value = vals.filter(item=>{if(item && item.time) return item})
                //         let val  = value && value[0] && moment(value[0].time).format(column.properties.format);
                //         return <span>{val}</span>
                //     }
                // }

                // 操作
                if (column.properties.operations !== undefined && column.properties.operations.length > 0) {
                    tableColumn["render"] = (text, record) => {
                        if (column.properties.transform !== undefined) {
                            return this.notify(column.properties.transform, record, text, undefined, column.properties.operations);
                            // return <Space size="middle">
                            //     {
                            //         column.properties.operations.map((item, index) => {
                            //             this.notify(column.properties.transform, record, text, undefined, column.properties.operations);
                            //             return <a key={index} onClick={()=>{ this.notify(item.click, record, text, undefined)}}>{item.name}</a>
                            //         })
                            //     }
                            //  </Space>
                        }
                        else {
                            return (
                                <Space size="middle">
                                    {
                                        column.properties.operations.map((item, index) => {
                                            return <a key={index} onClick={() => { this.notify(item.click, record, text) }}>{item.name}</a>
                                        })
                                    }
                                </Space>
                            )
                        }
                    }
                }
                else if (column.properties.transform !== undefined) {
                    tableColumn["render"] = (text, record) => {

                        return this.notify(column.properties.transform, record, text)
                    }

                }
            }


            tableColumns.push(tableColumn);
        }

        return tableColumns;
    }

    /**
     * 创建数据
     */
    buildData(data, pagination) {
        const { options, width } = this.state;

        let tableData = [];


        if (options !== undefined) {
            for (let i = 0; i < data.length; i++) {
                let item = data[i];
                if (options.isSerial !== false && data !== undefined && data.length > 0) {
                    item["serial"] = (pagination.current - 1) * pagination.pageSize + 1 + i;
                }

                if (options.check && options.check.enable) {
                    item["key"] = item[options.check.key]
                }
                tableData.push(item);
            }
        }

        if (tableData.length > 0) {
            return tableData;
        }
        else {
            return data;
        }
    }

    updateRect() {
        const { bordered } = this.state;
        if (this.myRef !== undefined) {
            if (this.myRef.current !== null) {
                const width = bordered ? this.myRef.current.clientWidth - 2 : this.myRef.current.clientWidth;


                if (this.state.width !== width) {
                    this.setState({ width: width, scroll: { x: width - 200 } });
                }

            }
        }
    }

    componentWillReceiveProps(nextProps) {
        const { page, total, selectedRowKeys, options = {}, columns } = nextProps;

        let { loading, pagination } = this.state;

        pagination["current"] = page && page.current && page.current || page || 1;
        pagination['pageSize'] = options.records || 10;

        let column = this.buildColumns();
        let data = this.buildData(nextProps.data, pagination);

        if (data !== undefined) {
            loading = false;
        }

        this.setState({ data: data, columns: column, total: total, loading: loading, selectedRowKeys: selectedRowKeys });
    }

    componentDidMount() {
        let { loading, pagination } = this.state;

        let { data, total } = this.props;

        let tableColumns = this.buildColumns();

        data = this.buildData(data, pagination);

        if (data !== undefined) {
            loading = false;
        }


        this.setState({ data: data, total: total, pagination: pagination, loading: loading, columns: tableColumns });

    }

    componentDidUpdate() {
        this.updateRect();
    }


    render() {
        const { columns, data, pagination, loading, total, rowSelection, rowKey, selectedRowKeys, locale, scroll, bordered, width } = this.state;
        const { options } = this.props;
        pagination["total"] = total;
        pagination["showTotal"] = () => { return <>共（{total}）条记录</> };

        if (rowSelection !== undefined) {
            rowSelection["selectedRowKeys"] = selectedRowKeys;
        }

        if (rowSelection !== undefined && options.type) {
            rowSelection["type"] = options.type;
        }

        return (
            //ref={this.myRef}
            <div className="sf-table sd-table sg-table" >
                <Table
                    locale={locale}
                    bordered={bordered}
                    rowSelection={rowSelection}
                    key={JSON.stringify(selectedRowKeys)}
                    columns={columns}
                    rowKey={record => record[rowKey]}
                    dataSource={data}
                    pagination={pagination}
                    loading={this.props.loading}
                    scroll={scroll}
                    onChange={this.onChange}
                />
            </div>
        )

    }
}

export default WidgetTable;
